export const getInitials = (name?: string | null): string => {
  if (!name || name.trim() === '') {
    return '';
  }

  const nameParts = name.trim().split(/\s+/);

  if (nameParts.length === 1) {
    return nameParts[0].substring(0, 1).toUpperCase();
  }

  const firstInitial = nameParts[0].substring(0, 1);
  const lastInitial = nameParts[nameParts.length - 1].substring(0, 1);

  return (firstInitial + lastInitial).toUpperCase();
};

export const getAvatarColor = (name?: string | null): string => {
  const colors = ['#316A7D', '#6DA6B9', '#4A515B', '#777D84', '#005C3E', '#875500'];

  if (!name || name.trim() === '') {
    return colors[0];
  }

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
};
